import _ from 'lodash'
import fp from 'lodash/fp.js'
import * as dfn from 'date-fns'
import * as fpdfn from 'date-fns/fp'
import ky from 'ky'

export const unops = {
  '!': a => !a
}

export const logops = {
  '||': (a, b) => a || b,
  '&&': (a, b) => a && b
}

export const binops = {
  '==': (a, b) => a === b,
  '!=': (a, b) => a !== b,
  '<': (a, b) => a < b,
  '>': (a, b) => a > b,
  '<=': (a, b) => a <= b,
  '>=': (a, b) => a >= b,
  '+': (a, b) => a + b,
  '-': (a, b) => a - b,
  '*': (a, b) => _.round(a * b, 3),
  '/': (a, b) => _.round(a / b, 3),
  '%': (a, b) => a % b
}

export const isLogop = op => _.chain(logops).keys().includes(op).value()

const regexTester = r => s => (new RegExp(_.toString(r), 'i')).test(_.toString(s))

const getFunctions = (o, prefix) => _.chain(o).pickBy(_.isFunction).mapKeys((v, k) => prefix ? `${prefix}_${k}` : k).value()

export const methods = {
  ...getFunctions(_),
  ...getFunctions(fp, 'fp'),
  ...getFunctions(dfn, 'dfn'),
  ...getFunctions(fpdfn, 'fp_dfn'),
  fp_lt: fp.gt,
  fp_lte: fp.gte,
  fp_gt: fp.lt,
  fp_gte: fp.lte,
  fp_avg: fp.mean,
  fp_ieq: other => fp.flow(fp.toLower, fp.eq(fp.__, _.toLower(other))),
  fp_regexMatch: regexTester,
  fp_oneOf: a => fp.includes(fp.__, a),
  len: fp.size,
  avg: fp.mean,
  ieq: (value, other) => _.eq(_.toLower(value), _.toLower(other)),
  isFilterEmpty: (a, p) => _.isEmpty(_.filter(a, p)),
  regexMatch: (s, r) => regexTester(r)(s),
  regexMatchSome: (a, r) => {
    const rt = regexTester(r)
    return _.chain(a).castArray().map(rt).some().value()
  },
  fp_sumLabelsByBucket: (labels, k = 'groups', by = 'sumAmount') => fp.flatMap(fp.flow(fp.get(k), fp.filter(fp.conforms({ label: fp.includes(fp.__, _.castArray(labels)) })), fp.sumBy(by))),
  fp_hasMatch: f => fp.flow(fp.filter(f), fp.negate(fp.isEmpty)),
  http_get: async (url, options) => {
    try {
      return await ky.get(url, {
        ...options,
        throwHttpErrors: false,
        hooks: {
          beforeRequest: [
            async (r, o) => {
              if (o?.oauth2?.tokenUrl && o?.oauth2?.clientId && o?.oauth2?.clientSecret) {
                const { access_token: accessToken, token_type: tokenType } = await ky.post(
                  o?.oauth2?.tokenUrl,
                  {
                    body: new URLSearchParams(_.pickBy({
                      grant_type: 'client_credentials',
                      client_id: o?.oauth2?.clientId,
                      client_secret: o?.oauth2?.clientSecret,
                      scope: o?.oauth2?.scope
                    }))
                  }
                ).json()

                r.headers.set('Authorization', `${tokenType} ${accessToken}`)
              }
            }
          ]
        }
      }).json()
    } catch (error) {
      if (error.name === 'HTTPError') {
        return await error.response.json()
      }

      return {
        message: error?.message || error?.name || _.toString(error)
      }
    }
  },
  storeData: (v, k, d) => {
    _.set(d, k, v)
    return v
  }
}
